import React, { useMemo } from 'react';
import { Bubble, BubbleProps } from 'tea-component';
import './index.scss';
import { uniqueArray } from '@/pages/opinion/utils';
import { useIntl } from 'umi';

export default function RingRatioBubble({
  title,
  otherInfo = null,
  oldTime,
  newTime,
  children,
  oldValue,
  newValue,
  placement = 'top',
  showContent = true,
  formateDate = (date: string) => date,
  formateValue = (value: number | string) => value + '',
  ...bubbleProps
}: {
  showContent?: boolean;
  oldTime: Array<string | undefined>;
  newTime: Array<string | undefined>;
  oldValue: number | string;
  newValue: number | string;
  title?: string;
  otherInfo?: any;
  children: any;
  placement?: String;
  formateDate?: (date: string) => string;
  formateValue?: (value: any) => string | number;
  bubbleProps?: React.ForwardRefExoticComponent<
    BubbleProps & React.RefAttributes<HTMLDivElement>
  >;
}) {
  const { formatMessage } = useIntl();

  const content = useMemo(() => {
    const noShow = !oldTime?.every(Boolean) && !newTime?.every(Boolean);

    if (showContent && !noShow) {
      const oldTimeText = uniqueArray(
        oldTime?.filter(Boolean)?.map(formateDate as any),
      )?.join(' - ');
      const newTimeText = uniqueArray(
        newTime?.filter(Boolean)?.map(formateDate as any),
      )?.join(' - ');

      const oldValueText = formateValue(oldValue);
      const newValueText = formateValue(newValue); 
      if (oldTimeText.length > 0 && (oldValueText || newValueText)) {
        return (
          <div className="bubble-box">
            {title && <div className="item-title">{title}</div>}
            {otherInfo}
            <div className="item-content">
              <div className="item-date-box">
                <div className="item-date">{newTimeText}</div>
                <div className="item-date">{oldTimeText} </div>
              </div>
              <div className="item-vs">VS</div>
              <div className="item-num-box">
                <div className="item-num">{newValueText}</div>
                <div className="item-num">{oldValueText}</div>
              </div>
            </div>
          </div>
        );
      }
    }

    return null;
  }, [showContent, oldTime, newTime, oldValue, newValue, title, formatMessage]);

  return (
    <Bubble
      dark
      className="ring-ratio-bubble-wrapper"
      overlayClassName={'ring-ration-bubble-box'}
      placement={placement as any}
      content={content}
      closeOnScroll
      {...bubbleProps}
      // trigger={'click'}
    >
      <span className="child-item dbo-ring-ratio-bubble-children-item">{children}</span>
    </Bubble>
  );
}
